module.exports = __webpack_public_path__ + "img/EXACTFLO_LOGO_BLACK_NOTEXT-03.92a4d631.png";